export { VideoFeatureSection as VideoTestimonialSection } from "../expanded-section-pack"